import React from 'react'
import { Link } from "react-router";

import Logo from "./vectors/logo_header.svg"

export default function Header() {
  return (
    <header>
      <div className='page-title'>

        <Link to="/" className='page-title-with-logo'>
        <img src={Logo} alt="logo" />
        <h1>Épületszimuláció.hu</h1>
        </Link>

        <nav className='nav-header'>
          <Link to="/about">Kik vagyunk?</Link> 
          <Link to="/services">Szolgáltatásaink</Link>
          <Link to="/ourwork">Hogy dolgozunk? </Link>
          <Link to="/references">Referenciáink </Link>
          <Link to="/contact">Kapcsolat</Link>
        </nav>

      </div>
    </header>
  )
}
